import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import bgImg from "../../pnai-admin-bg.jpg";
import Logo from "../common/Logo";
import Button from "../common/Button";
import Input from "../common/Input";
import Loading from "../common/Loading";

function AgencyResetPasswordEmailInput() {
  const [email, setEmail] = useState<string>("");
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [errorState, setErrorState] = useState<boolean>(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !/\S+@\S+\.\S+/.test(email)) {
      setErrors({ email: "Please enter a valid email address" });
      setErrorState(true);
      return;
    }

    setLoading(true);
    try {
      await axios.post("/api/agency/resetpassword/new", {
        email,
      });
      alert(
        "If an account exists with this email, you will receive reset instructions shortly."
      );
      navigate("/agency/login");
    } catch (error) {
      setErrorState(true);
      setErrors({
        overall: "An error occurred. Please try again later.",
      });
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2">
      <div
        className="hidden md:flex relative items-center justify-center bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${bgImg})` }}
      >
        <div className="absolute inset-0 bg-blue-50/70"></div>
        <div className="w-3/5 z-10">
          <Logo className="w-full h-auto" />
        </div>
      </div>
      <div className="flex items-center justify-center min-h-screen bg-gray-100 dark:bg-base-200">
        <div className="bg-base-100 p-8 rounded-xl shadow-md w-full max-w-sm">
          <h1 className="text-3xl mb-4 font-semibold">Forgot Password?</h1>

          <form className="space-y-4" onSubmit={handleSubmit}>
            <div>
              <p className="text-base-content/60 text-sm pb-4">
                Enter your agency admin email address and we'll send you
                instructions to reset your password.
              </p>
              <p className="font-semibold pb-1 text-sm">Admin Email</p>
              <Input
                type="email"
                id="email"
                value={email}
                placeholder="Email address"
                onChange={(e) => {
                  errorState && setErrorState(false);
                  setEmail(e.target.value);
                }}
                className={`input w-full ${errorState && "border-red-500"}`}
              />
              {errors.email && errorState && (
                <p className="mt-1 text-xs text-red-500">{errors.email}</p>
              )}
            </div>
            <div>
              <Button className="w-full" variant="primary" type="submit">
                Send Reset Instructions
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AgencyResetPasswordEmailInput;
